// Librerias
import React from 'react'
let PropTypes = React.PropTypes
// CSS
import * as css from './TablaFacturas.css'
// Componente
import { RowFactura } from './RowFactura.jsx'

export class TablaFacturas extends React.Component{
    render(){
        let totalFacturas = this.props.facturas.length
        return <div className="row">
            <TablaFactoring>
                {_.range(0, totalFacturas).map(index=>{
                    let factura = this.props.facturas[index]
                    return <RowFactura
                        ref={index}
                        key={factura? factura.fac_idFactura : index}
                        factura={factura}
                        correlativo={index+1}
                    />
                })}
            </TablaFactoring>
        </div>
    }
}
TablaFacturas.propTypes = {
}
let TablaFactoring = ({children})=>
    <div className={'panel panel-primary'}>
        <div className={'panel-heading'}>
            {'Facturas disponibles para descargar'}
        </div>
        <table className={'table table-striped table-hover no-margin table-condensed '+css.tablaFacturas}>
            <thead>
            <tr>
                <th className={css.thCorrelativo}>#</th>
                <th className={css.thDocumento}>Documento</th>
                <th className={css.thNumero}>Folio</th>
                <th className={css.thFecha}>Fecha Emisión</th>
                <th className={css.thFecha}>Fecha Vencimiento</th>
                <th className={css.thMonto}>Monto Neto</th>
                <th className={css.thMonto}>Monto Bruto</th>
                <th className={css.thDescarga}>Descarga</th>
            </tr>
            </thead>
            <tbody>
            {children}
            </tbody>
        </table>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/facturacion/lista-facturas/cliente-fcv/TablaFacturas.jsx